import { ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useAuth } from "@/modules/auth/hooks/use-auth"
import { usePluginInstalls } from "@/modules/marketplace/hooks/usePluginInstalls"
import {
  selectCurrentOrganization,
  selectCurrentOrganizationId,
} from "@/modules/organizations/store/organizationSlice"
import { getOrganizationRoles } from "@/modules/organizations/utils/organization-roles"
import { buildNavSections, firstNavPath, isModuleAccessOnly } from "@/modules/layout/config/nav-config"

const PROFILE_PATH = "/account/profile"

// The dashboard shows the platform's recruitment and onboarding figures, so members with add-on access only
// start on the first add-on page their roles open instead.
export function ModuleOnlyRedirect({ children }: { children: ReactElement }) {
  const { permissions } = useAuth()
  const { activeFamilies, hasLoaded } = usePluginInstalls()
  const currentOrg = useSelector(selectCurrentOrganization)
  const currentOrganizationId = useSelector(selectCurrentOrganizationId)

  const orgRoles = getOrganizationRoles(currentOrg)
  if (!isModuleAccessOnly(orgRoles)) return children
  if (!hasLoaded) return null

  const landing = firstNavPath(
    buildNavSections({
      currentPlan: currentOrg?.plan,
      currentOrgId: currentOrganizationId,
      userRoles: orgRoles,
      userPermissions: permissions,
      activePluginFamilies: activeFamilies,
      moduleAccessOnly: true,
    }),
  )

  return <Navigate to={landing ?? PROFILE_PATH} replace />
}
